var map = {
	"./katakana_hyphen-compressor.gif": "W+M6",
	"./katakana_large_a-compressor.gif": "XBDH",
	"./katakana_large_ba-compressor.gif": "yVoh",
	"./katakana_large_be-compressor.gif": "OMMY",
	"./katakana_large_bi-compressor.gif": "FZ9M",
	"./katakana_large_bo-compressor.gif": "QE4W",
	"./katakana_large_bu-compressor.gif": "TNsa",
	"./katakana_large_chi-compressor.gif": "zc3X",
	"./katakana_large_da-compressor.gif": "AK+j",
	"./katakana_large_de-compressor.gif": "g/Ws",
	"./katakana_large_di-compressor.gif": "N9EM",
	"./katakana_large_do-compressor.gif": "Tb++",
	"./katakana_large_du-compressor.gif": "o8iQ",
	"./katakana_large_e-compressor.gif": "tPlF",
	"./katakana_large_ga-compressor.gif": "8+S7",
	"./katakana_large_ge-compressor.gif": "mskg",
	"./katakana_large_gi-compressor.gif": "gFZM",
	"./katakana_large_go-compressor.gif": "WWx4",
	"./katakana_large_gu-compressor.gif": "URxp",
	"./katakana_large_ha-compressor.gif": "27kc",
	"./katakana_large_he-compressor.gif": "gPo+",
	"./katakana_large_hi-compressor.gif": "Pw9Z",
	"./katakana_large_ho-compressor.gif": "fH0/",
	"./katakana_large_hu-compressor.gif": "A2xB",
	"./katakana_large_i-compressor.gif": "BoVw",
	"./katakana_large_ka-compressor.gif": "de87",
	"./katakana_large_ke-compressor.gif": "alhk",
	"./katakana_large_ki-compressor.gif": "GNBY",
	"./katakana_large_ko-compressor.gif": "TKkd",
	"./katakana_large_ku-compressor.gif": "eMir",
	"./katakana_large_ma-compressor.gif": "jEPl",
	"./katakana_large_me-compressor.gif": "4dWI",
	"./katakana_large_mi-compressor.gif": "THt8",
	"./katakana_large_mo-compressor.gif": "l0Ev",
	"./katakana_large_mu-compressor.gif": "wz1e",
	"./katakana_large_na-compressor.gif": "zDdB",
	"./katakana_large_ne-compressor.gif": "xaik",
	"./katakana_large_ni-compressor.gif": "a0uk",
	"./katakana_large_nn-compressor.gif": "8eBy",
	"./katakana_large_no-compressor.gif": "0oWA",
	"./katakana_large_nu-compressor.gif": "MvB9",
	"./katakana_large_o-compressor.gif": "0LOe",
	"./katakana_large_pa-compressor.gif": "PNhw",
	"./katakana_large_pe-compressor.gif": "9SR0",
	"./katakana_large_pi-compressor.gif": "W4/q",
	"./katakana_large_po-compressor.gif": "3Kb4",
	"./katakana_large_pu-compressor.gif": "lWGi",
	"./katakana_large_ra-compressor.gif": "xnrv",
	"./katakana_large_re-compressor.gif": "3ywZ",
	"./katakana_large_ri-compressor.gif": "5hEA",
	"./katakana_large_ro-compressor.gif": "9AV6",
	"./katakana_large_ru-compressor.gif": "5mnE",
	"./katakana_large_sa-compressor.gif": "EkQC",
	"./katakana_large_se-compressor.gif": "9lfV",
	"./katakana_large_shi-compressor.gif": "vTc3",
	"./katakana_large_so-compressor.gif": "svyX",
	"./katakana_large_su-compressor.gif": "eQjz",
	"./katakana_large_ta-compressor.gif": "edXd",
	"./katakana_large_te-compressor.gif": "23a8",
	"./katakana_large_to-compressor.gif": "xaEa",
	"./katakana_large_tsu-compressor.gif": "YRG0",
	"./katakana_large_u-compressor.gif": "BgFz",
	"./katakana_large_wa-compressor.gif": "pzdU",
	"./katakana_large_we-compressor.gif": "4Vsd",
	"./katakana_large_wi-compressor.gif": "WlrA",
	"./katakana_large_wo-compressor.gif": "kILm",
	"./katakana_large_ya-compressor.gif": "Gora",
	"./katakana_large_yo-compressor.gif": "motG",
	"./katakana_large_za-compressor.gif": "/uQ5",
	"./katakana_large_ze-compressor.gif": "W01F",
	"./katakana_large_zi-compressor.gif": "y5Mf",
	"./katakana_large_zo-compressor.gif": "+3Ba",
	"./katakana_large_zu-compressor.gif": "oRBb",
	"./katakana_small_a-compressor.gif": "4sfa",
	"./katakana_small_e-compressor.gif": "qCBd",
	"./katakana_small_i-compressor.gif": "FT1L",
	"./katakana_small_o-compressor.gif": "/37e",
	"./katakana_small_tsu-compressor.gif": "lLmI",
	"./katakana_small_u-compressor.gif": "XCGy",
	"./katakana_small_ya-compressor.gif": "d83Y",
	"./katakana_small_yo-compressor.gif": "yP7C",
	"./katakana_small_yu-compressor.gif": "JNZ6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XC8l";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif ^\.\/katakana_.*\-compressor\.gif$
// module id = XC8l
// module chunks = 0